import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import ReactSVG from 'react-svg';


import UpdateBusinessContainer from '@containers/business/crud/UpdateBusinessContainer';
import LocationContainer from '@containers/location/LocationContainer';

import Collapsible from '@uicomponents/Collapsible';
import Loader from '@uicomponents/Loader';

import { administrativeReferenceToString } from '@utils/locationUtils';

import ContactDetailsView from '../general/ContactDetailsView';
import NotesView from '../note/NotesView';

class BusinessView extends Component {
  render() {
    const { t, business, isFetchingBusiness, onChange, addToStack } = this.props;

    if (!business || isFetchingBusiness) {
      return <Loader />;
    }
    return (
      <div className="business-view">
        <div className="flex-container justify-between no-wrap">
          <div>
            <div className="flex-container justify-between">
              <h1 className="no-margin">{business.name}</h1>
            </div>
            <h3 className="no-margin-top">#{business.id}</h3>
          </div>
          <div className="self-center flex-container action-icons">
            <div
              className="action-icon"
              onClick={(e) => {
                e.preventDefault();
                addToStack({
                  name: t('business.update.header'),
                  component: (
                    <UpdateBusinessContainer
                      targetBusiness={{ ...business }}
                      callback={(result) => {
                        onChange('business', result.business || {});
                      }}
                    />
                  ),
                });
              }}
            >
              <ReactSVG src="/icons/pencil.svg" />
            </div>
          </div>
        </div>
        {business.coc && (
          <div>
            <b>{t('business.coc')}</b>: {business.coc}
          </div>
        )}
        {business.vat && (
          <div>
            <b>{t('business.vat')}</b>: {business.vat}
          </div>
        )}
        {business.website && (
          <div>
            <b>{t('business.website')}</b>:{' '}
            <a href={business.website} target="_blank" rel="noopener noreferrer">
              {business.website}
            </a>
          </div>
        )}
        {business.description && (
          <div>
            <b>{t('business.description')}</b>: {business.description}
          </div>
        )}
        {business.locations
          .map((assocation) => assocation.entity)
          .map((location, index) => {
            return (
              <div>
                <b>
                  {t('business.location')} #{index + 1}
                </b>
                :{' '}
                <div
                  className="as-link"
                  onClick={(e) => {
                    e.preventDefault();
                    addToStack({
                      name: location.name,
                      component: <LocationContainer location={{ ...location }} />,
                    });
                  }}
                >
                  {administrativeReferenceToString(location.administrativeReference)}
                </div>
              </div>
            );
          })}
        <Collapsible
          name={`${t('notes.header')}${
            business.notes.length > 0 ? ` (${business.notes.length})` : ''
          }`}
          className="collapsible-element"
          defaultIsOpen={false}
        >
          <NotesView notes={business.notes} />
        </Collapsible>
        <Collapsible
          name={`${t('contactDetails.header')}${
            business.contactDetails.length > 0 ? ` (${business.contactDetails.length})` : ''
          }`}
          className="collapsible-element"
          defaultIsOpen={false}
        >
          <ContactDetailsView contactDetails={business.contactDetails} />
        </Collapsible>
      </div>
    );
  }
}
export default withTranslation('translation')(BusinessView);
